'use strict';

const RequestHandler = require('./../../../core/requestHandler');

/**
 * Save.
 * @param {string} key
 * @param {object} data
 * @returns {Promise} Return promise
 */
module.exports.save = function(key, data) {
  let currentApiUrl = RequestHandler.getBaseUrl();
  let dfd;

  RequestHandler.setBaseUrl('/api');
  dfd = RequestHandler.update('user-preferences/' + key, data);
  RequestHandler.setBaseUrl(currentApiUrl);

  return dfd;
};

/**
 * Delete.
 * @param {string} key
 * @returns {Promise} Return promise
 */
module.exports.del = function(key) {
  let currentApiUrl = RequestHandler.getBaseUrl();
  let dfd;

  RequestHandler.setBaseUrl('/api');
  dfd = RequestHandler.del('user-preferences/' + key);
  RequestHandler.setBaseUrl(currentApiUrl);

  return dfd;
};

/**
 * Find.
 * @param {string} key
 * @returns {Promise} Return promise
 */
module.exports.find = function(key) {
  let currentApiUrl = RequestHandler.getBaseUrl();
  let dfd;

  RequestHandler.setBaseUrl('/api');
  dfd = RequestHandler.read('user-preferences/' + key);
  RequestHandler.setBaseUrl(currentApiUrl);

  return dfd;
};
